import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";
import { TextInput, SelectBox, PrimaryButton, SelectSwitch, AleartModalButton, HelpIcon } from "../../components/UIkit";
import { OpusSelectBox } from "../../components/opuses";
import { deleteBooth, saveBooth } from "../../reducks/booths/operations";
import { getMyOpuses } from "../../reducks/opuses/selectors";
import { getUserId, getUserName } from "../../reducks/users/selectors";
import { fetchMyOpuses } from "../../reducks/opuses/operations";
import { fechSelectedBooth } from "../../reducks/booths/operations";
import { OrganizerHeader } from "../../components/header";
import AddPhotoAlternateIcon from "@material-ui/icons/AddPhotoAlternate";
import { getSelectedBooth } from "../../reducks/booths/selectors";
import "date-fns";
import Grid from "@material-ui/core/Grid";
import DateFnsUtils from "@date-io/date-fns";
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from "@material-ui/pickers";
import "../../assets/css/boothEdit.css";

const BoothEdit = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const uid = getUserId(selector);
  const opuses = getMyOpuses(selector);
  const booth = getSelectedBooth(selector);
  const isBoothEditing = false;
  const isOpusEditing = true;
  const username = getUserName(selector);
  const [id, setId] = useState(""),
    [boothName, setBoothName] = useState(""),
    [selectOpuses, setSelectOpuses] = useState([]),
    [organizerName, setOrganizerName] = useState(username),
    [description, setDescription] = useState(""),
    [release, setRelease] = useState({ state: true }),
    [youtubeChannelId, setYoutubeChannelId] = useState(""),
    [youtubeApiKey, setYoutubeApiKey] = useState(""),
    [isBlack, setIsBlack] = useState(true),
    [isGothic, setIsGothic] = useState(true),
    [cheerPrice, setCheerPrice] = useState(""),
    [isCheer, setIsCheer] = useState(true);

  const [selectedDateBase, setSelectedDateBase] = useState(new Date());
  console.log(selectedDateBase);

  const selectedDate =
    // selectedDateBase.getFullYear() +
    // "/" +
    ("0" + (selectedDateBase.getMonth() + 1)).slice(-2) + "月" + ("0" + selectedDateBase.getDate()).slice(-2) + "日";
  const selectedTime =
    ("0" + selectedDateBase.getHours()).slice(-2) + ":" + ("0" + selectedDateBase.getMinutes()).slice(-2);
  // console.log(selectedDate);
  // console.log(selectedTime);

  const handleDateChange = (date) => {
    setSelectedDateBase(date);
  };

  const handleChange = (event) => {
    setRelease({ ...release, [event.target.name]: event.target.checked });
  };

  const inputBoothName = useCallback(
    (event) => {
      setBoothName(event.target.value);
    },
    [setBoothName]
  );

  const inputDescription = useCallback(
    (event) => {
      setDescription(event.target.value);
    },
    [setDescription]
  );

  const inputOrganizerName = useCallback(
    (event) => {
      setOrganizerName(event.target.value);
    },
    [setOrganizerName]
  );
  const inputYoutubeChannelId = useCallback(
    (event) => {
      setYoutubeChannelId(event.target.value);
    },
    [setYoutubeChannelId]
  );
  const inputYoutubeApiKey = useCallback(
    (event) => {
      setYoutubeApiKey(event.target.value);
    },
    [setYoutubeApiKey]
  );
  const inputCheerPrice = useCallback(
    (event) => {
      setCheerPrice(event.target.value);
    },
    [setCheerPrice]
  );

  const selectBackColor = [
    { id: true, name: "黒" },
    { id: false, name: "白" },
  ];
  const selectFont = [
    { id: true, name: "ゴシック" },
    { id: false, name: "明朝" },
  ];
  const selectCheer = [
    { id: true, name: "ON" },
    { id: false, name: "OFF" },
  ];

  const resetSelectOpuses = () => {
    setSelectOpuses([]);
  };

  const validateRequiredInput = (...args) => {
    let isBlank = false;
    for (let i = 0; i < args.length; i = (i + 1) | 0) {
      if (args[i] === "") {
        isBlank = true;
      }
    }
    return isBlank;
  };

  const validateRequiredOpus = (selectOpuses) => {
    let isValidOpus = false;
    if (selectOpuses.length > 2) {
      isValidOpus = true;
    }
    return isValidOpus;
  };

  const submitBooth = () => {
    const isBlank = validateRequiredInput(
      boothName,
      organizerName,
      isBlack,
      isGothic,
      youtubeChannelId,
      youtubeApiKey,
      release,
      isCheer,
      cheerPrice,
      selectedDateBase
    );
    const isValidOpus = validateRequiredOpus(selectOpuses);
    if (isBlank) {
      alert("必須入力欄が空白です。");
      return false;
    } else if (!isValidOpus) {
      alert("作品の登録は3点以上が必須となります");
      return false;
    } else {
      dispatch(
        saveBooth(
          id,
          uid,
          selectOpuses,
          boothName,
          description,
          organizerName,
          isBlack,
          isGothic,
          selectedDateBase,
          selectedDate,
          selectedTime,
          youtubeChannelId,
          youtubeApiKey,
          release,
          isCheer,
          cheerPrice
        )
      );
    }
  };

  const fechBoothData = () => {
    const liveScheduleData = booth.liveSchedule;
    const liveSchedule = liveScheduleData.toDate();
    setBoothName(booth.boothName);
    setDescription(booth.description);
    setOrganizerName(booth.organizerName);
    setSelectOpuses(booth.selectOpuses);
    setIsGothic(booth.isGothic);
    setIsBlack(booth.isBlack);
    setIsCheer(booth.isCheer);
    setYoutubeChannelId(booth.youtubeChannelId);
    setYoutubeApiKey(booth.youtubeApiKey);
    setCheerPrice(booth.cheerPrice);
    setRelease(booth.release);
    setSelectedDateBase(liveSchedule);
  };

  useEffect(() => {
    let getid = window.location.pathname.split("/booth/edit/")[1];
    setId(getid);
    dispatch(fetchMyOpuses(uid));
    if (getid !== "") {
      dispatch(fechSelectedBooth(getid));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (id !== "") {
      fechBoothData();
    }
    // eslint-disable-next-line
  }, [booth]);

  return (
    <section>
      <div className="common-container">
        <div className="common-container__header--inner center-box">
          <OrganizerHeader isBoothEditing={isBoothEditing} isOpusEditing={isOpusEditing} />
          <div className="mypage-container">
            <div className="spacer-box--l"></div>
            <h2 className="form-text__headline--l center">BOOTHの設立</h2>
            <div className={"common-section-container"}>
              <h3 className="form-text__headline--m center">1.作品の登録</h3>
              <div className="spacer-box--ss" />
              {id !== "" ? (
                <OpusSelectBox
                  label={"追加する作品を選んでください(必須)"}
                  required={true}
                  options={opuses}
                  select={setSelectOpuses}
                  value={selectOpuses ?? ""}
                  defaultValue={selectOpuses ?? ""}
                />
              ) : (
                <OpusSelectBox
                  label={"出品する作品を選んでください"}
                  required={true}
                  options={opuses}
                  select={setSelectOpuses}
                  value={selectOpuses ?? ""}
                />
              )}

              <div className="basic-text--s center">
                {id && (
                  <>
                    <div className="spacer-box--s" />
                    <div className="booth-index-headline">選択中の作品一覧</div>
                    <div className="spacer-box--ss" />
                    {selectOpuses && (
                      <div>
                        {selectOpuses.map((opus) => (
                          <div key={opus.id}>
                            <div className="booth-index-title">{opus.name}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
                <div className="spacer-box--s" />

                <AleartModalButton
                  title="選択した作品をリセットします"
                  text="よろしいですか？"
                  onClick={() => resetSelectOpuses()}
                  label="リセット"
                  className="top-back-btn"
                />
              </div>
              <div className="spacer-box--m" />
              <div className="basic-text--s center">※未登録の場合は下記のボタンから作品の登録ができます</div>
              <div className="spacer-box--s" />
              <div className="center">
                <AleartModalButton
                  title="保存されいない内容は消去されます"
                  text="よろしいですか？"
                  onClick={() => dispatch(push("/opus/edit/"))}
                  label="作品登録"
                  icon={<AddPhotoAlternateIcon style={{ fontSize: 20 }} />}
                  className="btn-box"
                />
              </div>
              <div className="spacer-box--l" />
              <h3 className="form-text__headline--m center">2.ブース情報の登録</h3>
              <TextInput
                fullWidth={true}
                label={"ブースタイトル(必須)"}
                multiline={false}
                required={true}
                onChange={inputBoothName}
                rows={1}
                value={boothName}
                type={"text"}
                helperText="※個展イベントの名称"
              />
              <div className="spacer-box--m" />
              <TextInput
                fullWidth={true}
                label={"作家名(必須)"}
                multiline={false}
                required={true}
                onChange={inputOrganizerName}
                rows={1}
                value={organizerName}
                type={"text"}
              />
              <div className="spacer-box--m" />
              <TextInput
                fullWidth={true}
                label={"ブースの説明"}
                multiline={true}
                required={true}
                onChange={inputDescription}
                rows={5}
                value={description}
                type={"text"}
              />
              <div className="spacer-box--m" />
              <SelectBox
                label={"背景色"}
                required={true}
                options={selectBackColor ?? ""}
                select={setIsBlack}
                value={isBlack}
                helperText="※一覧表示サムネイルの背景の色"
              />
              <SelectBox
                label={"フォント"}
                required={true}
                options={selectFont ?? ""}
                select={setIsGothic}
                value={isGothic}
                helperText="※一覧表示サムネイルのフォントの種類"
              />
              <div className="spacer-box--l" />
              <h3 className="form-text__headline--m center">3.LIVE情報の登録</h3>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <Grid container justify="space-around">
                  <KeyboardDatePicker
                    fullWidth
                    margin="normal"
                    id="date-picker-dialog"
                    label="LIVE配信をする日付"
                    format="yyyy年MM月dd日"
                    value={selectedDateBase ?? ""}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                  <KeyboardTimePicker
                    fullWidth
                    margin="normal"
                    id="time-picker"
                    label="LIVE配信をする時間"
                    value={selectedDateBase ?? ""}
                    onChange={handleDateChange}
                    KeyboardButtonProps={{
                      "aria-label": "change time",
                    }}
                  />
                </Grid>
              </MuiPickersUtilsProvider>
              <div className="spacer-box--m" />
              <TextInput
                fullWidth={true}
                label={"YoutubeChannelのID"}
                multiline={false}
                required={true}
                onChange={inputYoutubeChannelId}
                rows={1}
                value={youtubeChannelId}
                type={"text"}
              />
              <div className="spacer-box--m" />
              <TextInput
                fullWidth={true}
                label={"YoutubeApiのKey"}
                multiline={false}
                required={true}
                onChange={inputYoutubeApiKey}
                rows={1}
                value={youtubeApiKey}
                type={"text"}
              />
              <div className="spacer-box--l" />
              <div className="flex-row">
                <h3 className="form-text__headline--m">4.応援機能の設定</h3>
                <div className="booth-edit-help-icon">
                  <HelpIcon
                    title="応援機能とは？"
                    text="応援機能をONに設定すると、あなた自身を応援するためのチケットを自動発行します。チケットは開催するブースごとに発行できますので、大事なイベントはチケット金額を上げたりすれば、ブランディングをサポートする機能になります。"
                  />
                </div>
              </div>
              <SelectBox
                label={"機能のON・OFF"}
                required={true}
                options={selectCheer ?? ""}
                select={setIsCheer}
                value={isCheer}
                helperText="※OFFにすると応援チケットは発行されません"
              />
              <div className="spacer-box--s" />
              <TextInput
                fullWidth={true}
                label={"応援チケットの価格"}
                multiline={false}
                required={true}
                onChange={inputCheerPrice}
                rows={1}
                value={cheerPrice}
                type={"number"}
              />
              <div className="spacer-box--ss" />
              <div className="basic-text--s center">※チケットの表紙は出品する作品から自動で選ばれます</div>
              <div className="spacer-box--l" />
              <SelectSwitch checked={release.state} onChange={handleChange} name="state" label="公開する" />
              <div className="spacer-box--m" />
              <div className="basic-text--s center">※公開スイッチを入れるとタイムラインに投稿されます</div>
              <div className="spacer-box--l" />
              <div className="center">
                <PrimaryButton label={"BOOTH情報を保存"} onClick={() => submitBooth()} />
                <div className="spacer-box--s" />
                <AleartModalButton
                  title="保存されいない内容は消去されます"
                  text="よろしいですか？"
                  onClick={() => dispatch(push(`/organizer/${uid}`))}
                  label="TOPへ戻る"
                  className="top-back-btn"
                />
                <div className="spacer-box--l" />
                <AleartModalButton
                  title="作品を削除します"
                  text="よろしいですか？"
                  onClick={() => dispatch(deleteBooth(id, uid))}
                  label="ブースを削除"
                  className="delete-btn"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BoothEdit;
